import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Header } from '../components/Header';
import { RequestCard } from '../components/RequestCard';
import { MOCK_REQUESTS } from '../utils/mockData';
export function RequestHistoryPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-201">
      <Header data-id="element-202" />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-8" data-id="element-203">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-500 hover:text-teal-600 mb-6 transition-colors text-sm font-medium" data-id="element-204">
          <ArrowLeft className="w-4 h-4 mr-1" data-id="element-205" />
          Back to Home
        </button>

        <div className="flex items-center justify-between mb-6" data-id="element-206">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-207">Request History</h2>
          <span className="text-sm text-gray-500 bg-white px-3 py-1 rounded-full border border-gray-200 shadow-sm" data-id="element-208">
            {MOCK_REQUESTS.length} Total
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-209">
          {MOCK_REQUESTS.map(request => <RequestCard key={request.id} request={request} data-id="element-210" />)}
        </div>

        {MOCK_REQUESTS.length === 0 && <div className="text-center py-12 bg-white rounded-xl border border-gray-100 shadow-sm" data-id="element-211">
            <p className="text-gray-500 mb-4" data-id="element-212">No requests found.</p>
            <button onClick={() => navigate('/')} className="text-teal-600 font-medium hover:underline" data-id="element-213">
              Make your first request
            </button>
          </div>}
      </main>
    </div>;
}